export default __webpack_public_path__ + "media/images/pdf-icone-371e10c2dfe47ee7ccb8dad5f9ae2b9d.gif";